<template>
  <div class="mt-2">
    <v-layout>
      <v-flex>
        <v-btn flat @click="cancelProduct">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <h3 v-if="!editData" class="headline mt-3">{{ $t('Add New Gift') }}</h3>
    <h3 v-else class="headline mt-3">{{ $t('Edit Gift') }}</h3>

    <!-- Category -->
    <div class="form-control" :class="{ 'has-error': errors.has('categoryInput') }">
      <label for="categoryInput" class="caption"
        >{{ $t('Member Type') }} <span class="red--text">*</span></label
      >
      <v-radio-group
        v-validate="'required'"
        v-model="category"
        name="categoryInput"
        row
        class="ma-0"
        @click="onChangeCategory"
      >
        <template v-for="(item, index) in categorylist">
          <v-radio color="primary" :key="index" :label="item.name" :value="item.id"></v-radio>
        </template>
      </v-radio-group>
      <span class="text-error" v-show="errors.has('categoryInput')">
        {{ errors.first('categoryInput') }}
      </span>
    </div>

    <!-- SubCategory -->
    <template v-if="loadingSubCategory">
      <div class="text-left">
        <scale-loader
          :color="$vuetify.theme.primary"
          height="20px"
          width="5px"
          style="max-width: 50px"
        ></scale-loader>
      </div>
    </template>
    <template v-else>
      <div class="form-control" :class="{ 'has-error': errors.has('subcategoryInput') }">
        <label v-if="subcategorylist" for="subcategoryInput" class="caption"
          >{{ $t('Sub Category') }} <span class="red--text">*</span></label
        >
        <v-radio-group
          v-validate="'required'"
          v-model="subcategory"
          :data-vv-as="$t('Sub Category')"
          name="subcategoryInput"
          row
          class="ma-0"
        >
          <template v-for="(item, index) in subcategorylist">
            <v-radio color="primary" :key="index" :label="item.name" :value="item.id"></v-radio>
          </template>
        </v-radio-group>
        <span class="text-error" v-show="errors.has('subcategoryInput')">
          {{ errors.first('subcategoryInput') }}
        </span>
      </div>
    </template>

    <!-- Product -->
    <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadImage') }">
      <!-- <upload-multiple-file
        v-model="productImages"
        :max="10"
        data-vv-name="uploadMultipleFile"
        data-vv-as="Preview Image"
      ></upload-multiple-file> -->

      <uploadfile
        :data-vv-as="$t('uploadImage')"
        name="Product Image"
        v-validate="'required'"
        v-model="photourl"
        style="max-width: 250px"
      ></uploadfile>

      <span class="text-error" v-show="errors.has('uploadImage')">
        {{ errors.first('uploadImage') }}
      </span>
    </div>
    <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
      <label class="caption" for="nameInput"
        >{{ $t('Product Name') }} <span class="red--text">*</span></label
      >
      <input
        type="text"
        class="form-control"
        ref="name"
        id="nameInput"
        name="nameInput"
        :data-vv-as="$t('Product Name')"
        aria-describedby="name"
        :placeholder="$t('Product Name')"
        v-model="name"
        v-validate="'required'"
      />
      <span class="text-error" v-show="errors.has('nameInput')">
        {{ errors.first('nameInput') }}
      </span>
    </div>
    <div class="row">
      <div class="col s12"></div>
      <div class="col s12 px-0">
        <div
          class="form-group form-control"
          :class="{ 'has-error': errors.has('descriptionInput') }"
        >
          <div>
            <label for="descriptionInput" class="caption"
              >{{ $t('Product detail') }} <span class="red--text">*</span></label
            >
          </div>
          <textarea
            type="text"
            class="form-control"
            id="descriptionInput"
            name="descriptionInput"
            style="resize: vertical; min-height: 90px; width: 100%"
            :data-vv-as="$t('Product detail')"
            aria-describedby="description"
            :placeholder="$t('Product detail')"
            row="3"
            v-model="description"
            v-validate="'required'"
          ></textarea>
          <span class="text-error" v-show="errors.has('descriptionInput')">
            {{ errors.first('descriptionInput') }}
          </span>
        </div>
      </div>
      <div class="col s6 px-0">
        <div class="form-group form-control" :class="{ 'has-error': errors.has('EffectiveDate') }">
          <div>
            <label for="EffectiveDate" class="caption"
              >{{ $t('Effective Date') }} <span class="red--text">*</span></label
            >
          </div>
          <div>
            <v-layout row class="ma-0">
              <v-flex xs10>
                <datepicker
                  class="form-control"
                  v-model="selectedEffectiveDate"
                  name="EffectiveDate"
                  placeholder="DD/MM/YYYY"
                  v-validate="'required'"
                  :data-vv-as="$t('Effective Date')"
                ></datepicker>
              </v-flex>
              <v-flex>
                <v-btn @click="clearDateTime('selectedEffectiveDate')" icon>
                  <v-icon>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
            <span class="text-error" v-show="errors.has('EffectiveDate')">
              {{ errors.first('EffectiveDate') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col s6 px-0">
        <div class="form-group form-control" :class="{ 'has-error': errors.has('EndDate') }">
          <div>
            <label for="EndDate" class="caption"
              >{{ $t('End Date') }} <span class="red--text">*</span></label
            >
          </div>
          <v-layout row class="ma-0">
            <v-flex xs10>
              <datepicker
                class="form-control"
                v-model="selectedEndDate"
                @selected="onSelectedEndDate"
                :data-vv-as="$t('End Date')"
                name="EndDate"
                placeholder="DD/MM/YYYY"
                v-validate="'required'"
              ></datepicker>
            </v-flex>
            <v-flex>
              <v-btn @click="clearDateTime('selectedEndDate')" icon> <v-icon>delete</v-icon></v-btn>
            </v-flex>
          </v-layout>
          <span class="text-error" v-show="errors.has('EndDate')">
            {{ errors.first('EndDate') }}
          </span>
        </div>
      </div>
      <!-- <div class="col s6 px-0">
        <div class="form-group">
          <v-switch
            v-model="oneTimeRedeem"
            :label="`1 Person / 1 Time`"
            class="ma-0"
          ></v-switch>
        </div>
      </div> -->
      <div class="col s5 px-0">
        <div class="form-control" :class="{ 'has-error': errors.has('numberOfRedeemInput') }">
          <label class="caption" for="numberOfRedeemInput">{{
            $t('Number of time that can be redeemed')
          }}</label>
          <input
            type="number"
            class="form-control mt-2"
            id="numberOfRedeemInput"
            name="numberOfRedeem"
            :data-vv-as="$t('Number of time that can be redeemed')"
            :placeholder="$t('Number of time that can be redeemed')"
            v-model="numberOfRedeem"
          />
          <span class="text-error" v-show="errors.has('numberOfRedeemInput')">
            {{ errors.first('numberOfRedeemInput') }}
          </span>
        </div>
      </div>
      <!-- <div class="col s6 px-0 mt-2">
        <div class="form-control" :class="{ 'has-error': errors.has('pickupOptionInput') }">
          <label for="pickupOptionInput" class="caption">{{ $t('Pickup Option') }} <span class="red--text">*</span></label>
            <v-radio-group
              v-validate="'required'"
              v-model="pickupOption"
              :data-vv-as="$t('Pickup Option')"
              name="pickupOption"
              row
            >
               <v-radio
                  color="primary"
                  label="รับที่สาขา"
                  value="รับที่สาขา"
                ></v-radio>
                 <v-radio
                  color="primary"
                  label="จัดส่ง"
                  value="จัดส่ง"
                ></v-radio>
            </v-radio-group>
          <span class="text-error" v-show="errors.has('pickupOptionInput')">
            {{ errors.first('pickupOptionInput') }}
          </span>
        </div>
      </div> -->
    </div>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="cancelProduct">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
// import SelectCategory from '@/components/view/template/ecommerce/SelectCategory.vue'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
// import datepicker from 'vuejs-datepicker'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

export default {
  props: ['categorylist', 'editData'],
  inject: ['$validator'],
  data: function () {
    return {
      currentView: 'Gift',
      productImages: [],

      photourl: null,
      name: null,
      description: null,
      selectedEffectiveDate: '',
      selectedEndDate: '',
      numberOfRedeem: null,
      isEdit: false,

      category: null,
      subcategory: null,
      subcategorylist: null,
      limit: 10,
      offset: 0,
      loadingSubCategory: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    }
  },
  mounted: async function () {
    var vm = this
    // vm.$refs.name.focus();
    await this.$nextTick()
    goTo(0)

    // if (Number.isInteger(vm.selectCategory)) {
    //   vm.currentCategory = vm.selectCategory
    // } else {
    //   vm.currentCategory = vm.selectCategory[0]
    // }

    if (vm.editData) {
      vm.isEdit = true
      vm.onEditProduct()
    }

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  components: {
    datepicker,
    // SelectCategory: SelectCategory,
    uploadfile: uploadfile,
    UploadMultipleFile,
    ScaleLoader,
    // DatepickerCustomDialog,
    CustomTimepicker
  },
  methods: {
    async getSubCategories(categoryId) {
      let vm = this
      vm.loadingSubCategory = true
      if (!vm.selectedBot) {
        return
      }

      var data = {
        pageid: vm.selectedBot.pageid,
        category_id: categoryId,
        limit: vm.limit,
        offset: vm.offset
      }

      await api.getLamyGiftSubCategory(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.subcategorylist = response.data
        vm.loadingSubCategory = false
      })
    },

    clearDateTime(name) {
      if (name == 'selectedEffectiveDate') {
        this.selectedEffectiveDate = ''
      } else if (name == 'selectedEndDate') {
        this.selectedEndDate = ''
      }
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
        // return val;
      } else {
        return ''
      }
    },
    onSelectedEndDate(value) {
      var vm = this

      if (moment(value).isBefore(vm.selectedEffectiveDate)) {
        vm.selectedEndDate = ''
      } else {
        vm.selectedEndDate = value
      }
    },
    cancelProduct: function () {
      var vm = this
      ;(vm.category = null), (vm.subcategory = null), (vm.photourl = '')
      vm.name = ''
      vm.description = ''
      vm.selectedEffectiveDate = ''
      vm.selectedEndDate = ''
      vm.numberOfRedeem = null
      vm.$emit('close')
    },
    onChangeCategory() {
      this.subcategory = ''
    },
    async saveProduct() {
      // return new Promise((resolve, reject) => {
      if (await this.$validator.validate()) {
        let vm = this
        let data = {
          pageid: vm.selectedBot.pageid,
          category_id: vm.category,
          sub_category_id: vm.subcategory,
          name: vm.name,
          details: vm.description,
          effective_date: vm.selectedEffectiveDate, // วันเริ่มแลกได้ YYYY-MM-DD
          end_date: vm.selectedEndDate, // วันสิ้นสุดที่แลกได้ YYYY-MM-DD
          limits: vm.numberOfRedeem, // จำนวนครั้งที่สามารถแลกได้
          photo_url: vm.photourl, // url รูป
          one_time: false,
          pickup: 'shipping'
        }

        if (!vm.isEdit) {
          api.postLamyGiftProduct(data, function (error, response) {
            // if (error) {
            //   console.error(error)
            //   return
            // }

            if (response.responsecode == 200) {
              vm.$emit('onAddProduct')
              vm.$emit('close')
              vm.cancelProduct()
            } else if (response.responsecode == 204) {
              Vue.swal.fire({ text: 'สร้างสินค้าไม่สำเร็จ' })
            } else {
              console.error(error)
              return
            }

            // resolve(response);
          })
        } else {
          var productId = this.editData.id
          Object.assign(data, { product_id: productId })

          api.putLamyGiftProduct(data, function (error, response) {
            if (error) {
              return
            }

            vm.$emit('onSaveProduct')
            vm.$emit('close')
            vm.cancelProduct()
            // resolve(response);
          })
        }
      }
    },
    onEditProduct() {
      var vm = this

      vm.getSubCategories(vm.editData.category_id)
      vm.category = vm.editData.category_id
      vm.subcategory = vm.editData.sub_category_id
      vm.photourl = vm.editData.photo_url
      vm.name = vm.editData.name
      vm.description = vm.editData.details
      vm.selectedEffectiveDate = vm.editData.effective_date
      vm.selectedEndDate = vm.editData.end_date
      vm.numberOfRedeem = vm.editData.limits
    }
  },
  watch: {
    category: function (newVal, oldVal) {
      var vm = this
      vm.getSubCategories(vm.category)
      // vm.subcategory = '';
      // if (Number.isInteger(vm.selectCategory)) {
      //   vm.currentCategory = vm.selectCategory
      // } else {
      //   vm.currentCategory = vm.selectCategory[0]
      // }
    }
  }
}
</script>

<style scroped>
.caption {
  font-size: 14px !important;
}
.v-btn-toggle .v-btn.v-btn--active {
  background-color: #ff706b !important;
  border-color: #ff706b !important;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ModalGift.vue